<template>
  <v-form ref="form">
    <v-card outlined>
      <v-card-text>
        <MarkdownEditor :label="$t('auditorFeedbackForm.feedback.label')" v-model="formData.feedback" @change="save" />
      </v-card-text>

      <v-card-actions>
        <v-btn color="primary" @click="save" :loading="loading" small>
          {{ $t("auditorFeedbackForm.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-snackbar v-model="saved" color="secondary">
      <div class="text-center flex-grow-1">
        {{ $t("action.saved") }}
      </div>
    </v-snackbar>
  </v-form>
</template>

<script>
import UpdateAuditorFeedbackStepModelRequirementMutation from "@/gql/mutations/UpdateAuditorFeedbackStepModelRequirementMutation.gql";
import MarkdownEditor from "@/components/Common/MarkdownEditor.vue";

export default {
  components: {
    MarkdownEditor,
  },

  props: {
    requirement: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      formData: {
        feedback: this.requirement.auditorFeedback,
      },
      loading: false,
      saved: false,
    };
  },

  methods: {
    async save() {
      this.loading = true;

      await this.$apollo.mutate({
        mutation: UpdateAuditorFeedbackStepModelRequirementMutation,
        variables: {
          id: this.requirement.id,
          feedback: this.formData.feedback,
        },
      });

      this.loading = false;
      this.saved = true;
    },
  },
};
</script>
